import { render } from "./layout-modern.vue?vue&type=template&id=77a9c240"
import script from "./layout-modern.vue?vue&type=script&lang=js"
export * from "./layout-modern.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__